
import styles from './advantage.module.css';

export function Advantage({ image, text, description }) {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.imageContainer}>
        <img className={styles.image} src={image} alt={text} />
      </div>
      <div className={styles.textContainer}>
        <p className={styles.text}>{text}</p>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  );
}
